<template>
  <div class="container">
    <div class="right">
      <el-row>
        <el-col :span="4">
          <el-input size="small" clearable placeholder="请输入任务名" prefix-icon="el-icon-search" v-model="search.keyword"
            @clear="clearKeyword">
          </el-input>
        </el-col>
        <el-col :span="4" :offset="1">
          <el-select v-model="search.status" placeholder="请选择" size="small">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4" :offset="1">
          <el-button type="primary" size="small" @click="taskList">搜索</el-button>
        </el-col>
        <el-col :span="2" :offset="8">
          <el-button size="small" type="primary" icon="el-icon-plus" @click="addTask">添加</el-button>
        </el-col>
      </el-row>
      <div class="distance">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="序号"></el-table-column>
          <el-table-column prop="name" label="任务编号"></el-table-column>
          <el-table-column prop="desc" label="任务描述"></el-table-column>
          <el-table-column prop="flow.name" label="关联流程"></el-table-column>
          <el-table-column prop="users" label="关联用户">
            <template slot-scope="scope">
              <template v-if="scope.row.users.length">
                <el-popover
                  placement="right"
                  width="250"
                  trigger="hover">
                  <el-table :data="scope.row.users">
                    <el-table-column width="100" property="name" label="姓名"></el-table-column>
                    <el-table-column width="150" property="mobile" label="手机号"></el-table-column>
                  </el-table>
                  <el-tag slot="reference">关联用户</el-tag>
                </el-popover>
              </template>
              <template v-else>所有用户</template>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="执行方式">
            <template slot-scope="scope">
              <span v-if="scope.row.type == 1">循环执行</span>
              <span v-else-if="scope.row.type == 2">Cron 表达式</span>
              <span v-else-if="scope.row.type == 3">立即执行</span>
              <span v-else>定时执行</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status == 1" type="success">启用</el-tag>
              <el-tag v-else type="danger">禁用</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-tooltip content="查看编辑" placement="top">
                <el-button @click="editTask(scope.row)" class="size" type="text" size="small" icon="el-icon-edit">
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagingVue :Pagination="Pagination" :tableData="tableData" @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange">
      </pagingVue>
    </div>

    <el-drawer :title="taskTitle" :visible.sync="showTaskDrawer" direction="rtl" @closed="taskDrawerClosed">
      <div style="padding: 16px;">
        <el-form ref="task" :model="task" :rules="taskRules" label-width="100px">
          <el-form-item label="任务描述" prop="desc">
            <el-input type="textarea" v-model="task.desc" placeholder="请填写任务描述" :disabled="contentDisabled"></el-input>
          </el-form-item>
          <el-form-item label="选择流程" prop="flow_id">
            <el-select v-model="task.flow_id" placeholder="请选择流程" :disabled="contentDisabled">
              <el-option v-for="item in flows" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关联用户" prop="users">
            <el-select v-model="task.users" multiple placeholder="请选择用户" :disabled="contentDisabled">
              <el-option
                v-for="item in users"
                :key="item.id"
                :label="item.mobile"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-divider content-position="left">执行计划</el-divider>
          <el-form-item label="优先执行" prop="exec_first">
            <el-switch v-model="task.exec_first" :disabled="contentDisabled" active-value="1" inactive-value="0"></el-switch>
          </el-form-item>
          <el-form-item label="分身执行" prop="clone_exec">
            <el-switch v-model="task.clone_exec" :disabled="contentDisabled" active-value="1" inactive-value="0"></el-switch>
          </el-form-item>
          <el-form-item label="执行方式" prop="exec_type">
            <el-radio-group v-model="task.exec_type" :disabled="contentDisabled" @input="changeExecType">
              <el-col :span="12">
                <el-radio :label="3">立即执行</el-radio>
                <el-radio :label="0">定时执行</el-radio>
              </el-col>
              <el-col>
                <el-radio :label="1">循环执行</el-radio>
                <el-radio :label="2">Cron 表达式</el-radio>
              </el-col>
            </el-radio-group>
          </el-form-item>

          <!-- 根据上面的执行方式渲染 -->
          <el-form-item label="定时方式" prop="time_type" v-if="showTimeType" class="item-margin-top">
            <el-radio-group v-model="task.time_type" :disabled="contentDisabled" @input="changeTimeType">
              <el-radio :label="1">按日期</el-radio>
              <el-radio :label="2">按星期</el-radio>
              <el-radio :label="3">按月</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="执行方式" prop="time_type2" v-if="showExecType" class="item-margin-top">
            <el-radio-group v-model="task.time_type2" :disabled="contentDisabled" @input="changeTimeType2">
              <el-radio :label="1">按日期 + 时间</el-radio>
              <el-radio :label="2">按时间</el-radio>
              <el-radio :label="3">按星期</el-radio>
              <el-radio :label="4">按月</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="开始" prop="startDate" v-if="showSEDate" class="item-margin-top">
            <el-date-picker
              :disabled="contentDisabled"
              v-model="task.startDate"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束" prop="endDate" v-if="showSEDate" class="item-margin-top">
            <el-date-picker
              :disabled="contentDisabled"
              v-model="task.endDate"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="日期" prop="dates" v-if="showDates" class="item-margin-top">
            <el-date-picker
              :disabled="contentDisabled"
              v-model="task.dates"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="请选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="星期" prop="weeks" v-if="showWeeks" class="item-margin-top">
            <el-checkbox-group v-model="task.weeks" :disabled="contentDisabled">
              <el-checkbox :label="7">周日</el-checkbox>
              <el-checkbox :label="1">周一</el-checkbox>
              <el-checkbox :label="2">周二</el-checkbox>
              <el-checkbox :label="3">周三</el-checkbox>
              <el-checkbox :label="4">周四</el-checkbox>
              <el-checkbox :label="5">周五</el-checkbox>
              <el-checkbox :label="6">周六</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="月份" prop="months" v-if="showMonths" class="item-margin-top">
            <el-checkbox-group v-model="task.months" :disabled="contentDisabled">
              <el-checkbox :label="13">全部</el-checkbox>
              <el-checkbox :label="1">一月</el-checkbox>
              <el-checkbox :label="2">二月</el-checkbox>
              <el-checkbox :label="3">三月</el-checkbox>
              <el-checkbox :label="4">四月</el-checkbox>
              <el-checkbox :label="5">五月</el-checkbox>
              <el-checkbox :label="6">六月</el-checkbox>
              <el-checkbox :label="7">七月</el-checkbox>
              <el-checkbox :label="8">八月</el-checkbox>
              <el-checkbox :label="9">九月</el-checkbox>
              <el-checkbox :label="10">十月</el-checkbox>
              <el-checkbox :label="11">十一月</el-checkbox>
              <el-checkbox :label="12">十二月</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="指定日" prop="setDate" v-if="showSetDate" class="item-margin-top">
            <el-radio-group v-model="task.setDate" :disabled="contentDisabled" @input="changeSetDate">
              <el-radio label="0">按日</el-radio>
              <el-radio label="1">当月最后一天</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="当月第" prop="days" v-if="showDays" class="item-margin-top">
            <el-select v-model="task.days" multiple placeholder="请选择" :disabled="contentDisabled">
              <el-option v-for="item in daysOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间范围" prop="time_range" v-if="showTimeRange" class="item-margin-top">
            <el-time-picker
              :disabled="contentDisabled"
              format="HH:mm:ss"
              value-format="HH:mm:ss"
              is-range
              v-model="task.time_range"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              placeholder="请选择时间范围">
            </el-time-picker>
          </el-form-item>
          <el-form-item label="时间" prop="times" v-if="showTimes" class="item-margin-top">
            <el-time-picker
              :disabled="contentDisabled"
              v-model="task.times"
              format="HH:mm:ss"
              value-format="HH:mm:ss"
              placeholder="请选择时间">
            </el-time-picker>
          </el-form-item>
          <el-form-item label="运行间隔" prop="interval" v-if="showInterval" class="item-margin-top">
            <el-row>
              <el-col :span="12">
                <el-input-number v-model="task.interval" :min="1" label="时间间隔" :disabled="contentDisabled"></el-input-number>
              </el-col>
              <el-col :span="6" :offset="1">
                <el-select v-model="task.interval_unit" placeholder="请选择" :disabled="contentDisabled">
                  <el-option value="1" label="秒"></el-option>
                  <el-option value="2" label="分钟"></el-option>
                  <el-option value="3" label="小时"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="Cron 表达式" prop="cron" v-if="showCron" class="item-margin-top">
            <el-input placeholder="Cron 表达式" v-model="task.cron" :disabled="contentDisabled"></el-input>
          </el-form-item>
          <el-form-item class="item-margin-top">
            <template v-if="task.id">
              <el-button :key="task.id" :disabled="task.exec_type == 3" :type="taskStatus ? 'danger' : 'primary'" @click="changeTaskStatus">{{ taskStatus ? "禁用 " : "启用" }}</el-button>
            </template>
            <template v-else>
              <el-button type="primary" @click="submitTask">设置</el-button>
              <el-button type="info" @click="showTaskDrawer = false">取消</el-button>
            </template>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import pagingVue from "../../components/Paging/paging.vue";

export default {
  name: "Promo_task",
  data() {
    var validateTimeRange = (rule, value, callback) => {
      if (value && value[0] && value[1]) {
        if (new Date('2024-01-01 ' + value[0]).getTime() > new Date('2024-01-01 ' + value[1]).getTime()) {
          callback(new Error('结束时间不能早于开始时间'));
        } else {
          callback();
        }
      }
    };
    return {
      taskStatus: 0,
      showTaskDrawer: false,
      taskTitle: "查看任务",
      search: {
        keyword: "",
        status: "",
        page: "",
      },
      Pagination: {},
      tableData: [],
      task: {
        id: 0,
        exec_first: "0",
        clone_exec: "0",
        exec_type: 3,
        time_type: "",
        time_type2: "",
        startDate: "",
        endDate: "",
        weeks: [],
        months: [],
        dates: "",
        times: "",
        time_range: "",
        interval: "0",
        interval_unit: "1",
        setDate: "0",
        days: [],
      },
      taskRules: {
        desc: [{ required: true, trigger: 'blur' }],
        flow_id: [{ required: true, trigger: 'blur' }],
        users: [{ required: true, trigger: 'blur' }],
        exec_type: [{ required: true, trigger: 'change' }],
        time_type: [{ required: true }],
        time_type2: [{ required: true }],
        startDate: [{ required: true }],
        endDate: [{ required: true }],
        dates: [{ required: true }],
        weeks: [{ required: true }],
        months: [{ required: true }],
        setDate: [{ required: true }],
        days: [{ required: true }],
        time_range: [
          { required: true },
          { validator: validateTimeRange, trigger: ['blur', 'change'] }
        ],
        times: [{ required: true }],
        interval: [{ required: true }],
        cron: [{ required: true }]
      },
      statusOptions: [
        {
          value: "",
          label: "全部"
        },
        {
          value: 0,
          label: "禁用",
        },
        {
          value: 1,
          label: "启用",
        }
      ],
      flows: {},
      users: [
        {
          id: 0,
          name: "所有用户",
          mobile: "所有用户"
        }
      ],
      daysOptions: [
        {
          label: 1,
          value: 1,
        },
        {
          label: 2,
          value: 2,
        },
        {
          label: 3,
          value: 3,
        },
        {
          label: 4,
          value: 4,
        },
        {
          label: 5,
          value: 5,
        },
        {
          label: 6,
          value: 6,
        },
        {
          label: 7,
          value: 7,
        },
        {
          label: 8,
          value: 8,
        },
        {
          label: 9,
          value: 9,
        },
        {
          label: 10,
          value: 10,
        },
        {
          label: 11,
          value: 11,
        },
        {
          label: 12,
          value: 12,
        },
        {
          label: 13,
          value: 13,
        },
        {
          label: 14,
          value: 14,
        },
        {
          label: 15,
          value: 15,
        },
        {
          label: 16,
          value: 16,
        },
        {
          label: 17,
          value: 17,
        },
        {
          label: 18,
          value: 18,
        },
        {
          label: 19,
          value: 19,
        },
        {
          label: 20,
          value: 20,
        },
        {
          label: 21,
          value: 21,
        },
        {
          label: 22,
          value: 22,
        },
        {
          label: 23,
          value: 23,
        },
        {
          label: 24,
          value: 24,
        },
        {
          label: 25,
          value: 25,
        },
        {
          label: 26,
          value: 26,
        },
        {
          label: 27,
          value: 27,
        },
        {
          label: 28,
          value: 28,
        },
        {
          label: 29,
          value: 29,
        },
        {
          label: 30,
          value: 30,
        },
        {
          label: 31,
          value: 31,
        }
      ],
      // 查看任务时候禁用
      contentDisabled: false,
      // 条件渲染表单
      showTimeType: false,
      showExecType: false,
      showSEDate: false,
      showInterval: false,
      showTimeRange: false,
      showDates: false,
      showWeeks: false,
      showMonths: false,
      showSetDate: false,
      showDays: false,
      showTimes: false,
      showCron: false,
    };
  },
  components: {
    pagingVue
  },
  mounted() {
    this.allFlows();
    this.allUsers();
  },
  activated() {
    this.taskList();
  },
  methods: {
    addTask() {
      this.allFlows();
      this.allUsers();
      this.showTaskDrawer = true;
      this.contentDisabled = false;
      this.taskTitle = "添加任务";
    },
    clearKeyword() {
      this.taskList();
    },
    async taskList() {
      await this.$axios
        .getListData("admin/promo/tasks", this.search)
        .then((res) => {
          if (res.code === 200) {
            this.Pagination = res.data.meta.pagination;
            let taskData = res.data.data;
            this.tableData = taskData.map((v) => {
              return {
                ...v,
                created_at: this.$inserted(v.created_at),
              };
            });
          }
        });
    },
    async allFlows() {
      await this.$axios.getListData("admin/promo/all-flows").then((res) => {
        if (res.code === 200) {
          this.flows = res.data;
        }
      })
    },
    async allUsers() {
      await this.$axios.getListData("admin/promo/all-users").then((res) => {
        if (res.code === 200) {
          this.users = [
            {
              id: 0,
              name: "所有用户",
              mobile: "所有用户"
            }
          ];
          this.users.push(...res.data);
        }
      })
    },
    // 分页
    handleSizeChange(val) {
      this.Pagination.per_page = val;
    },
    handleCurrentChange(val) {
      this.search.page = val;
      this.taskList();
    },
    editTask(row) {
      this.taskTitle = "查看任务";
      this.taskStatus = row.status
      this.showTaskDrawer = true;
      if (row.users.length) {
        this.task.users = row.users.map((v) => {
          return v.mobile;
        });
      } else {
        this.task.users = ['所有用户'];
      }
      this.contentDisabled = true;

      // 数据回填渲染
      this.task.id = row.id
      this.task.desc = row.desc
      this.task.flow_id = row.flow_id
      this.task.exec_type = row.type
      this.task.exec_first = row.exec_first.toString()
      this.task.clone_exec = row.clone_exec.toString()

      let setting = JSON.parse(row.content)
      if (row.type == 2) {
        // cron 表达式
        this.showCron = true
        this.task.cron = setting.text
      } else if (row.type == 0) {
        // 定时执行
        this.task.time_type = setting.type
        this.showTimeType = true

        if (setting.type == 1) {
          this.task.dates = setting.date
          this.showDates = true
        } else if (setting.type == 2) {
          this.task.weeks = setting.date.split(',').map((item) => item - 0)
          this.showWeeks = true
        } else {
          let months = setting.months.split('|').map((item) => item - 0)
          if (months.length == 12) {
            this.task.months = [13];
          } else {
            this.task.months = months
          }
          this.showMonths = true
          this.task.setDate = setting.monthType
          this.showSetDate = true
          if (setting.monthType == 0) {
            this.task.days = setting.days.split('|')
            this.showDays = true
          }
        }
        this.task.times = setting.time
        this.showTimes = true
      } else if (row.type == 1) {
        // 循环执行
        this.task.time_type2 = setting.type
        this.showExecType = true

        if (setting.type == 1) {
          // 按日期+时间
          let dateRange = setting.date.split(',')
          this.task.startDate = dateRange[0]
          this.task.endDate = dateRange[1]
          this.showSEDate = true
        } else if (setting.type == 2) {
          // 按时间
          this.task.time_range = setting.date.split(',')
          this.showTimeRange = true
        } else {
          if (setting.type == 3) {
            // 按星期
            this.task.weeks = setting.weekdays.split(',').map((item) => item - 0)
            this.showWeeks = true
          } else {
            // 按月
            let months = setting.months.split('|').map((item) => item - 0)
            if (months.length == 12) {
              this.task.months = [13];
            } else {
              this.task.months = months
            }
            this.showMonths = true
            this.task.setDate = setting.monthType
            this.showSetDate = true
            if (setting.monthType == 0) {
              this.task.days = setting.days.split('|')
              this.showDays = true
            }
          }
          this.task.time_range = setting.date.split(',')
          this.showTimeRange = true
        }

        this.task.interval = setting.interval
        this.task.interval_unit = setting.unit
        this.showInterval = true
      }
    },
    // 添加任务处理
    submitTask() {
      let submitTaskContent = {
        flow_id: this.task.flow_id,
        desc: this.task.desc,
        user_ids: this.task.users.join(','),
        exec_first: parseInt(this.task.exec_first),
        clone_exec: parseInt(this.task.clone_exec),
        type: this.task.exec_type,
        content: {
          type: "",
          date: "",
          time: this.task.times,
          interval: this.task.interval,
          unit: this.task.interval_unit,
          text: this.task.cron,
          months: "",
          monthType: this.task.setDate,
          days: this.task.days.join('|'),
          weekdays: this.task.weeks.join(','),
        },
      };

      // type 和 date 特殊处理
      if (this.task.exec_type == 0) {
        // 定时执行
        submitTaskContent.content.type = this.task.time_type;
        if (this.task.time_type == 1) {
          submitTaskContent.content.date = this.task.dates;
        } else {
          submitTaskContent.content.date = this.task.weeks.join(',');
        }
      } else if (this.task.exec_type == 1) {
        // 循环执行
        submitTaskContent.content.type = this.task.time_type2;
        // 日期+时间 1 or 时间 2 or 星期 3 or 月 4
        if (this.task.time_type2 == 1) {
          // 日期+时间
          submitTaskContent.content.date = this.task.startDate + ',' + this.task.endDate;
        } else {
          // 时间、星期、月
          submitTaskContent.content.date = this.task.time_range.join(',');
        }
      }

      // months
      if (this.task.months.indexOf(13) !== -1) {
        submitTaskContent.content.months = '1|2|3|4|5|6|7|8|9|10|11|12';
      } else {
        submitTaskContent.content.months = this.task.months.join('|');
      }

      // 选择全部用户时，此字段不提交
      if (submitTaskContent.user_ids.indexOf(0) !== -1) {
        delete submitTaskContent.user_ids;
      }

      // 格式化 json 字符串
      submitTaskContent.content = JSON.stringify(submitTaskContent.content);

      this.$refs['task'].validate((valid) => {
        if (valid) {
          let postTaskUrl = 'admin/promo/tasks';
          this.$axios.postListData(postTaskUrl, submitTaskContent)
            .then((res) => {
              if (res.code === 200) {
                this.showTaskDrawer = false;
                this.$refs['task'].resetFields();
                this.task = {
                  id: 0,
                  exec_first: "0",
                  clone_exec: "0",
                  exec_type: 3,
                  time_type: "",
                  time_type2: "",
                  startDate: "",
                  endDate: "",
                  weeks: [],
                  months: [],
                  dates: "",
                  times: "",
                  time_range: "",
                  interval: "0",
                  interval_unit: "1",
                  setDate: "0",
                  days: [],
                }
                this.taskList();
              }
            });
        } else {
          return false;
        }
      })
    },
    taskDrawerClosed() {
      this.$refs['task'].resetFields();
      this.task = {
        id: 0,
        exec_first: "0",
        clone_exec: "0",
        exec_type: 3,
        time_type: "",
        time_type2: "",
        startDate: "",
        endDate: "",
        weeks: [],
        months: [],
        dates: "",
        times: "",
        time_range: "",
        interval: "0",
        interval_unit: "1",
        setDate: "0",
        days: [],
      }
      this.showTimeType = false
      this.showExecType = false
      this.showSEDate = false
      this.showInterval = false
      this.showTimeRange = false
      this.showDates = false
      this.showWeeks = false
      this.showMonths = false
      this.showSetDate = false
      this.showDays = false
      this.showTimes = false
      this.showCron = false
      this.taskList();
      this.taskStatus = 0
    },
    changeExecType(e) {
      if (e == 0) {
        this.showTimeType = true
        this.showExecType = false
        this.showSEDate = false
        this.showInterval = false
        this.showTimeRange = false
        this.showDates = false
        this.showWeeks = false
        this.showMonths = false
        this.showSetDate = false
        this.showDays = false
        this.showTimes = true
        this.showCron = false
      } else if (e == 1) {
        this.showTimeType = false
        this.showExecType = true
        this.showSEDate = false
        this.showInterval = true
        this.showTimeRange = false
        this.showDates = false
        this.showWeeks = false
        this.showMonths = false
        this.showSetDate = false
        this.showDays = false
        this.showTimes = false
        this.showCron = false
      } else if (e == 2) {
        this.showTimeType = false
        this.showExecType = false
        this.showSEDate = false
        this.showInterval = false
        this.showTimeRange = false
        this.showDates = false
        this.showWeeks = false
        this.showMonths = false
        this.showSetDate = false
        this.showDays = false
        this.showTimes = false
        this.showCron = true
      } else {
        this.showTimeType = false
        this.showExecType = false
        this.showSEDate = false
        this.showInterval = false
        this.showTimeRange = false
        this.showDates = false
        this.showWeeks = false
        this.showMonths = false
        this.showSetDate = false
        this.showDays = false
        this.showTimes = false
        this.showCron = false
      }
    },
    changeTimeType(e) {
      if (e == 1) {
        this.showDates = true
        this.showWeeks = false
        this.showMonths = false
        this.showSetDate = false
        this.showDays = false
      } else if (e == 2) {
        this.showDates = false
        this.showWeeks = true
        this.showMonths = false
        this.showSetDate = false
        this.showDays = false
      } else {
        this.showDates = false
        this.showWeeks = false
        this.showMonths = true
        this.showSetDate = true
        this.showDays = true
      }
    },
    changeSetDate(e) {
      if (e == 0) {
        this.showDays = true
      } else {
        this.showDays = false
      }
    },
    changeTimeType2(e) {
      if (e == 1) {
        this.showSEDate = true
        this.showTimeRange = false
        this.showMonths = false
        this.showSetDate = false
        this.showWeeks = false
        this.showDays = false
      } else if (e == 2) {
        this.showSEDate = false
        this.showTimeRange = true
        this.showMonths = false
        this.showSetDate = false
        this.showWeeks = false
        this.showDays = false
      } else if (e == 3) {
        this.showSEDate = false
        this.showTimeRange = true
        this.showMonths = false
        this.showSetDate = false
        this.showWeeks = true
        this.showDays = false
      } else {
        this.showSEDate = false
        this.showTimeRange = true
        this.showMonths = true
        this.showSetDate = true
        this.showWeeks = false
        this.showDays = true
      }
    },
    changeTaskStatus() {
      this.$confirm("确定要修改此任务的状态吗？", "提示", {
        confirmButtonText: "确定",
      }).then(() => {
        this.$axios.postListData("admin/promo/change-task-status", {
          id: this.task.id,
        }).then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "修改成功",
            })
            this.showTaskDrawer = false
          } else {
            this.$message({
              type: "error",
              message: res.message,
            })
          }
        })
      }).catch(() => {});
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.cell {
  max-height: 28px !important;
}

/deep/.el-table__empty-text {
  line-height: 53px;
}

/deep/.el-table__empty-block {
  min-height: 53px;
}

/deep/.el-dialog__body {
  padding: 20px;
}

/deep/.el-dialog__headerbtn .el-dialog__close {
  color: #909399;
  display: none;
}

/deep/.el-message-box__headerbtn .el-message-box__close {
  display: none;
  color: #909399;
}

/deep/.el-button--text {
  font-size: 18px;
  margin-top: -8px;
}

/deep/.el-table__body {
  width: 100% !important;
}

/deep/.el-select {
  width: 100% !important;
}

/deep/.el-form-item {
  margin-bottom: 12px;
}

/deep/.el-radio-group {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.dialog-footer {
  display: flex !important;
  justify-content: space-around !important;
}

.container {
  width: 100%;
  box-sizing: border-box;
  padding: 30px;
  overflow: hidden;

  .right-item {
    margin: 20px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .distance {
    margin: 10px 0;
  }

  .right {
    .flex-list {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .flex {
      display: flex;
      align-items: center;
    }
  }

  /deep/.el-dialog__body {
    padding: 20px !important;
  }

  .item-margin-top {
    margin-top: 20px;
  }
}
</style>
    